// extracted by mini-css-extract-plugin
export default {"login":"Register_login__TeagF","boxInput":"Register_boxInput__AFDDR","errorText":"Register_errorText__Bfqu8","switchPage":"Register_switchPage__qK3k7"};